export default __webpack_public_path__ + "static/media/criminal7.16ad6e32.jpg";